import { useParams } from 'react-router-dom';

import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import NotFound from '@/components/common/NotFound';
import AddRegionTaxDialog from './AddRegionTaxDialog';
import RegionTaxRow from './RegionTaxRow';

const TaxList = ({ regionTaxes }) => {
  const params = useParams();

  if (regionTaxes.length === 0) {
    return (
      <div>
        <h3 className="text-lg font-bold mb-6 flex justify-between items-center">
          Region Taxes{' '}
          <AddRegionTaxDialog
            regionId={params.regionId}
            regionTaxes={regionTaxes}
          />
        </h3>
        <NotFound title="No Taxes Found" />
      </div>
    );
  }

  return (
    <div>
      <h3 className="text-lg font-bold flex justify-between items-center">
        Region Taxes{' '}
        <AddRegionTaxDialog
          regionId={params.regionId}
          regionTaxes={regionTaxes}
        />
      </h3>
      <Card className="mt-4">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Label</TableHead>
              <TableHead className="text-right">Rate</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {regionTaxes.map((regionTax) => (
              <RegionTaxRow
                key={regionTax.id}
                regionTaxes={regionTaxes}
                regionTax={regionTax}
                regionId={params.regionId}
              />
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {regionTaxes.length}
        </span>
      </div>
    </div>
  );
};

export default TaxList;
